import {  motion } from 'framer-motion';
import styled from 'styled-components';
import { setVh } from 'utils/styles/mixins';
import { mediaMobile } from 'utils/styles/responsive';
import { colors, layout } from 'utils/styles/theme';

export const Wrapper = styled(motion.div)`
    width: 100%;
    height: ${setVh(100)};
    overflow: hidden;
    z-index: ${layout.zIndex.modals + 1};
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${colors.black}
    button {
        > svg {
            width: 21px;
        }
    }

`;

export const ThumbsCarouselWrapper = styled.div`
    position: absolute;
    bottom: 40rem;
    > .ThumbsCarouselWrapper {
        width: 100%;
        padding-top: 50px;
        padding-bottom: 50px;
        
        .swiper-slide {
            background-position: center;
            background-size: cover;
            width: 130px;
            height: 90px;
        }

        .swiper-slide img {
            display: block;
            width: 100%;
            border: 1px solid red;
        }

        ${mediaMobile(`
            .swiper-slide {
                background-position: center;
                background-size: cover;
                width: 90px;
                height: 130px;
            }

            .swiper-slide img {
                display: block;
                width: auto;
                height: 100%;
                border: 1px solid red;
            } 
        `)}
    }
`;
export const FullCarouselWrapper = styled.div`
    width: 100vw;
    height: ${setVh(100)};
    overflow: hidden;
    positio: relative;
    > .ThumbsCarouselWrapper {
        width: 100vw;
        
        .swiper-slide {
            background-position: center;
            background-size: cover;
            width: 100%;
            height: 10%;
        }

        .swiper-slide img {
            display: block;
            width: 100%;
        }
    }
`;
export const CloseWrapper = styled(motion.div)`
    width: 60rem;
    height: 60rem;
    overflow: hidden;
    position: fixed;
    top: 120rem;
    right: 84rem;
    cursor: pointer;
    z-index: ${layout.zIndex.modals + 1};

    ${mediaMobile(`
        top: 50rem;
        right: 50%; 
        transform: translateX(50%);
    `)}
`;

export const Image = styled.img`
    width: 100%;
    height: auto;
    ${mediaMobile(`
        width: auto;
        height: ${setVh(100)};
    `)}
`;
export const CarouselItemOverlay = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.4);
`;

export const Content = styled(motion.div)`
    position: absolute;
    left: 0;
    top: 140rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    user-select: none;
    color: ${colors.white};
    text-align: center;
    z-index: ${layout.zIndex.modals + 1};
`;

export const ContentControls = styled(motion.div)`
    width: 80%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    user-select: none;
    z-index: ${layout.zIndex.modals + 1};
    position: absolute;
    left: 50%;
    top: 50%;
    max-width: 500rem;
    transform: translateX(-50%) translateY(-50%);

    > svg {
        width: 21px;
    }

   ${mediaMobile(`   
        width: 80%;    
  `)}
`;

export const ContentTitle = styled.h3`
    font-family: FontRegular;
    color: #FFF;
    font-size: 48rem;
    text-transform: uppercase;
    text-shadow: 0px 0px 8px rgba(0, 0, 0, 1);
    color: ${colors.white};

  ${mediaMobile(`    
    font-size: 24rem;
  `)}
`;

export const ContentSubtitle = styled.h5`
    width: 90%;
    font-family: FontLight;  
    font-size: 24rem;
    line-height: normal;
    text-shadow: 0px 0px 8px rgba(0, 0, 0, 1);
    color: ${colors.white};
    max-width: 700rem;

  ${mediaMobile(`    
    font-size: 12rem;
    margin-top: 16rem;
  `)}
`;

